import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectDependentIgnoreList } from '../redux/form/form.selectors';

import FormInput from '../form-input/FormInput.jsx';
import FormSelect from '../form-select/FormSelect.jsx';
import FormRadio from '../form-radio/FormRadio.jsx';
import FormCheckbox from '../form-checkbox/FormCheckbox.jsx';
import FormDate from '../form-date/FormDate.jsx';
import FormSectionDivider from '../form-section-divider/FormSectionDivider.jsx';
import FormHidden from '../form-hidden/FormHidden.jsx';

const FormInputWrapper = ({
  inputConfiguration,
  autoPopulate,
  triggerValidation,
  formStepValidation,
  dependentIgnoreList
  }) => {
  const [ isOnIgnoreList, setIsOnIgnoreList ] = useState(false);

  /**
   * When the dependent questions have triggered an update to the ignore list
   */
  useEffect(() => {
    let ignoreComponent = false;

    /**
     * Don't render any inputs that fail to match
     * their dependent conditions.
     */
    for (let i = 0, j = dependentIgnoreList.length; i < j; ++i) {
      if (
        dependentIgnoreList.indexOf(inputConfiguration.inputReference) !== -1 ||
        dependentIgnoreList.indexOf(inputConfiguration.inputName) !== -1
        ) {
        // Skip rendering this input
        ignoreComponent = true;
      }
    }

    setIsOnIgnoreList(ignoreComponent);
  }, [dependentIgnoreList]);

  const getFormComponent = () => {
    const combinedInputConfiguration = {
      autoPopulate: autoPopulate,
      triggerValidation: triggerValidation,
      formStepValidation: formStepValidation,
      ...inputConfiguration
    };

    switch (combinedInputConfiguration.inputType) {
      case 'text':
      case 'textarea':
      case 'email':
      case 'integer':
        return (
          <FormInput
            {...combinedInputConfiguration}
          />
        );

      case 'select':
        return (
          <FormSelect
            {...combinedInputConfiguration}
          />
        );

      case 'radio':
        return (
          <FormRadio
            {...combinedInputConfiguration}
          />
        );

      case 'checkbox':
        return (
          <FormCheckbox
            {...combinedInputConfiguration}
          />
        );

      case 'date':
        return (
          <FormDate
            {...combinedInputConfiguration}
          />
        );

      case 'section-divider':
        return (
          <FormSectionDivider
            {...combinedInputConfiguration}
          />
        );

      case 'hidden':
        return (
          <FormHidden
            {...combinedInputConfiguration}
          />
        );

      default:
        return (
          <div className="qld__form-group qld__form-style-filled qld__form-group--invalid co-xs-12">
            <span className="qld__label">Alert</span>
            <p className="sq-form-error">Error in component: &quot;FormInputWrapper&quot;. Unrecognised input type provided. Type: &quot;{combinedInputConfiguration.inputType}&quot;</p>
          </div>
        );
    }
  };

  return (
    !isOnIgnoreList ? (
      <>
        {
          (inputConfiguration.leadingTitle) ? <p className="qld__display-sm custom-online-form__fields-single-column">{inputConfiguration.leadingTitle}</p> : null
        }
        {
          (inputConfiguration.leadingText) ? <p className="custom-online-form__fields-single-column">{inputConfiguration.leadingText}</p> : null
        }
        { getFormComponent() }
      </>
    ) : null
  );
};

FormInputWrapper.propTypes = {
  "inputConfiguration": PropTypes.object.isRequired,
  "autoPopulate": PropTypes.bool,
  "triggerValidation": PropTypes.object,
  "formStepValidation": PropTypes.number.isRequired,
  "dependentIgnoreList": PropTypes.array.isRequired
};

const mapStateToProps = (state) => {
  return {
    "dependentIgnoreList": selectDependentIgnoreList(state)
  }
};

export default connect(mapStateToProps)(FormInputWrapper);